import { Alert, AlertTitle, Button, ButtonGroup, Box, Typography } from '@mui/material';
import { useContext, useState } from 'react';
import { UserContext } from '../../context';
import { createUserAgreement } from '../../fetch';

export const UserAgreement = () => {
  const { user, isLoading, loadUser } = useContext(UserContext);
  const [isAccepting, setAccepting] = useState(false);

  const handleAgreement = async (type: string) => {
    setAccepting(true);
    await createUserAgreement({
      username: user.userName,
      personId: user?.externalUser?.personId ?? null,
      isAccepted: type === 'Accept' ? true : false
    });
    loadUser();
    setAccepting(false);
  };
  if (!user || isLoading || user?.userAgreementCompleted) {
    return null;
  }

  return (
    <Alert
      severity="info"
      sx={{
        width: '100%',
        zIndex: 99999,
        position: 'fixed',
        bottom: 0
      }}
    >
      <AlertTitle sx={{ fontWeight: 'bold', marginBottom: 0 }}>Notice</AlertTitle>
      <Typography sx={{ marginBottom: '1rem' }}>
        This website tracks your IP address to present the best possible content and experience.
      </Typography>
      <Box>
        <ButtonGroup>
          <Button
            color="primary"
            size="small"
            variant="contained"
            disabled={isAccepting}
            onClick={() => handleAgreement('Accept')}
          >
            Accept
          </Button>
          <Button
            color="inherit"
            size="small"
            variant="contained"
            disabled={isAccepting}
            onClick={() => handleAgreement('Deny')}
          >
            Don't Accept
          </Button>
        </ButtonGroup>
      </Box>
    </Alert>
  );
};
